import { render, staticRenderFns } from "./NoticeCombined.vue?vue&type=template&id=878e98d2&scoped=true&"
import script from "./NoticeCombined.vue?vue&type=script&lang=js&"
export * from "./NoticeCombined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878e98d2",
  null
  
)

export default component.exports